'use strict';

const calloutHelper = require('./calloutHelper');

const calloutActions = {
    openCallout(actionContext, payload, done) {
        calloutHelper.saveAndTrack(payload);
        actionContext.dispatch('callout:open', payload);
        done();
    },

    closeCallout(actionContext, payload, done) {
        actionContext.dispatch('callout:close', payload);
        done();
    },

    closeAllCallouts(actionContext, payload, done) {
        calloutHelper.resetCallout();
        actionContext.dispatch('callout:closeAll', payload);
        done();
    },

    stopCallouts(actionContext, payload, done) {
        calloutHelper.stopCallouts();
        done();
    }
};

module.exports = calloutActions;



// WEBPACK FOOTER //
// ./assets/js/components/Callout/calloutActions.es.js